import Swiper, {Autoplay, Navigation, EffectCreative, Pagination} from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

const setSwiperWrapperMinHeight = (wrapper, cardsArr) => {
  let maxHeight = 0;

  cardsArr.forEach((item) => {
    const itemContainer = item.querySelector('.process-card__wrap');
    const itemTitle = item.querySelector('.process-card__title-wr');
    const itemContent = item.querySelector('.process-card__content');

    if (!itemContainer || !itemTitle) return;

    const containerStyles = window.getComputedStyle(itemContainer);
    const paddingTop = parseFloat(containerStyles.paddingTop);
    const paddingBottom = parseFloat(containerStyles.paddingBottom);
    const containerHeight = itemContainer.offsetHeight;
    const contentHeight = itemContent.offsetHeight;
    const titleHeight = itemTitle.offsetHeight;

    const totalHeight = contentHeight + paddingTop + paddingBottom + titleHeight;
    maxHeight = Math.max(maxHeight, totalHeight);
    console.log(totalHeight)
  });

  if (maxHeight > 0) {
    wrapper.style.minHeight = `${maxHeight + 40}px`;
  }
};

// Функция для определения iOS
const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

let processSwiperWr = document.querySelectorAll('.process-swiper-wr');
processSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let paginationEl = el.querySelector('.swiper-pagination');
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    const processCardsArr = el.querySelectorAll('.process-card');

    const MIN_CONTENT_HEIGHT = window.innerWidth > 1279 ? 90 : 108;

    const updateContentHeights = () => {
      const processCardsArr = el.querySelectorAll('.process-card');

      let maxCardHeight = 0;

      processCardsArr.forEach((item) => {
        const itemContainer = item.querySelector('.process-card__wrap');
        const itemTitle = item.querySelector('.process-card__title-wr');
        const itemWrap = item.querySelector('.process-card__container');
        const itemContent = item.querySelector('.process-card__content');

        if (!itemContainer || !itemTitle || !itemContent) return;

        const containerStyles = window.getComputedStyle(itemContainer);
        const titleHeight = itemTitle.offsetHeight;
        const paddingTop = parseFloat(containerStyles.paddingTop);
        const paddingBottom = parseFloat(containerStyles.paddingBottom);
        const containerHeight = itemContainer.offsetHeight;

        let availableHeight = containerHeight - titleHeight - paddingTop - paddingBottom;
        const contentInnerHeight = itemContent.scrollHeight;

        const finalHeight = Math.max(availableHeight, MIN_CONTENT_HEIGHT);
        const finalInnerHeight = Math.max(contentInnerHeight, MIN_CONTENT_HEIGHT);

        itemContent.style.setProperty('--content-height', `${finalHeight}px`);
        itemWrap.style.setProperty('--content-height', `${finalHeight}px`);
        itemContent.style.setProperty('--content-inner-height', `${finalInnerHeight}px`);

        maxCardHeight = Math.max(maxCardHeight, itemContainer.offsetHeight);
      });
    };

    processCardsArr.forEach((item) => {
      item.addEventListener("click", () => {
        if(item.classList.contains("is-active")) {
          item.classList.remove("is-active");
        } else {
          item.classList.add("is-active");
        }
      })
    })

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Pagination, EffectCreative],
      observer: true,
      observeParents: true,
      effect: 'creative',
      centeredSlides: true,
      slidesPerView: 5,
      threshold: 10,
      loop: true,
      loopAdditionalSlides: 2,
      slideToClickedSlide: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      creativeEffect: {
        perspective: true,
        limitProgress: 3,
        progressMultiplier: 1,
        prev: {
          translate: ['-100%', 0, -100],
          scale: 0.7,
        },
        next: {
          translate: ['100%', 0, -100],
          scale: 0.7,
        },
      },
      breakpoints: {
        640: {
          slidesPerView: 5,
          creativeEffect: {
            perspective: true,
            limitProgress: 3,
            progressMultiplier: 1,
            prev: {
              translate: ['-108%', 0, -100],
              scale: 0.8,
            },
            next: {
              translate: ['108%', 0, -100],
              scale: 0.8,
            },
          },
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
        waitForTransition: true,
        stopOnLastSlide: false,
      },
      on: {
        init: function () {
          setTimeout(updateContentHeights, 100);
          setTimeout(() => {
            setSwiperWrapperMinHeight(wrapper, processCardsArr)
          }, 200);

          // Для iOS - запускаем autoplay принудительно после инициализации
          if (isIOS()) {
            setTimeout(() => {
              if (this.autoplay && !this.autoplay.running) {
                this.autoplay.start();
              }
            }, 300);
          }
        },
        resize: function () {
          updateContentHeights();
        },
        slideChange: function () {
          updateContentHeights();
        },
        // Перезапуск autoplay после взаимодействия (для iOS)
        touchEnd: function() {
          if (isIOS() && this.autoplay) {
            setTimeout(() => {
              this.autoplay.start();
            }, 100);
          }
        },
        // Обработка клика по слайду
        click: function() {
          if (isIOS() && this.autoplay && !this.autoplay.running) {
            this.autoplay.start();
          }
        }
      },
    });

    swiperObserver(swiper);

    // Для iOS - запуск autoplay при первом взаимодействии с документом
    if (isIOS()) {
      const startAutoplayOnInteraction = () => {
        if (swiper.autoplay && !swiper.autoplay.running) {
          swiper.autoplay.start();
        }
        // Удаляем слушатели после первого срабатывания
        document.removeEventListener('touchstart', startAutoplayOnInteraction);
        document.removeEventListener('click', startAutoplayOnInteraction);
        swiperEl.removeEventListener('touchstart', startAutoplayOnInteraction);
      };

      // Добавляем множественные точки входа для запуска autoplay
      document.addEventListener('touchstart', startAutoplayOnInteraction, { once: true, passive: true });
      document.addEventListener('click', startAutoplayOnInteraction, { once: true });
      swiperEl.addEventListener('touchstart', startAutoplayOnInteraction, { once: true, passive: true });

      // Также пробуем запустить через небольшую задержку
      setTimeout(() => {
        if (swiper.autoplay && !swiper.autoplay.running) {
          swiper.autoplay.start();
        }
      }, 500);
    }

    window.addEventListener('resize', () => {
      setSwiperWrapperMinHeight(wrapper, processCardsArr);
    });
  }
});